import { UIMStoreMembershipProductView } from '../../main_page/body/store/UIMStoreMembershipProductView.ts';
export class UIMSubscriptionOverlayMembershipProductView extends UIMStoreMembershipProductView {
    onDoubleTapPurchaseFinished(purchaseResult) {
        super.onDoubleTapPurchaseFinished(purchaseResult);
        if (purchaseResult.isSuccessfulPurchase) this.onSuccessfulPurchase(this.getColonistMembershipType());
    }
    constructor(container, storeState, membershipProduct, onSuccessfulPurchase, localizedSubscription, localizedMonthlySubscription){
        super(container, storeState, membershipProduct, undefined, localizedSubscription, localizedMonthlySubscription);
        this.onSuccessfulPurchase = onSuccessfulPurchase;
    }
}
